import { toast } from '@crono-one/design-system/side-effects';
import { List } from 'crono-fe-common/types/list';
import { generatePath } from 'react-router-dom';
import { LIST_DETAIL_PATH } from 'routing/listInterceptor/paths';
import { withBasename } from 'utils/basename';

/** Shared with nobody: neither the whole team nor any teammate. */
export const isPrivateList = (list: Pick<List, 'shared' | 'sharedUsers'>) =>
  !list.shared && !list.sharedUsers?.length;

export const getListShareUrl = (listId: number) => {
  const appUrl = process.env.VITE_APP_FE_URL || window.location.origin;
  const path = generatePath(LIST_DETAIL_PATH, { listId: String(listId) });
  return `${appUrl}${withBasename(path)}`;
};

export const copyListShareLink = async (listId: number) => {
  try {
    await navigator.clipboard.writeText(getListShareUrl(listId));
    toast.success('Shareable link copied to your clipboard');
  } catch {
    toast.error('Failed to copy share link');
  }
};
